import { render, staticRenderFns } from "./PlaysDuration.vue?vue&type=template&id=621b6c50&scoped=true"
import script from "./PlaysDuration.vue?vue&type=script&lang=js"
export * from "./PlaysDuration.vue?vue&type=script&lang=js"
import style0 from "./PlaysDuration.vue?vue&type=style&index=0&id=621b6c50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621b6c50",
  null
  
)

export default component.exports